
















































import { Component, Vue, Prop } from 'vue-property-decorator';

/**
 * API
 */
import usersAPI from '@/api/users';
import authenticationAPI from '@/api/authentication';

/**
 * Helpers
 */
import { getFullName, getInitials } from "@/utils/users-helpers";

/**
 * Components
 */
import ChangePasswordDialog from './components/ChangePasswordDialog.vue';
import ChangeEmailDialog from './components/ChangeEmailDialog.vue';

/**
 * Composant de consultation du profil d'un usager.
 */
@Component({
	components: { ChangePasswordDialog, ChangeEmailDialog },
})
export default class UserProfilePage extends Vue {
	$refs!: {
		changePasswordDialog: ChangePasswordDialog,
		changeEmailDialog: ChangeEmailDialog
	};

	/** Injections */
	getFullName = getFullName;
	getInitials = getInitials;
	authenticationAPI = authenticationAPI;

	/** Attributs */
	isLoading = false;
	profile: any = null;

	/** Méthodes */
	async created() {
		this.isLoading = true;
		this.profile = await usersAPI.getCurrent();
		this.isLoading = false;
	}

	handleOpenChangePasswordDialog() {
		this.$refs.changePasswordDialog.open();
	}

	handleOpenChangeEmailDialog() {
		this.$refs.changeEmailDialog.open(this.profile.email, async () => {
			this.profile = await usersAPI.getCurrent();
		});
	}
}
